import { useApi } from '~/api';
import { components } from '~~/api-types';

export type SearchResultCardDto = components['schemas']['SearchResultCardDto'];
export type SearchResultsResponseDto =
  components['schemas']['SearchResultsResponseDto'];
export type SearchResultCardProgressDto =
  components['schemas']['SearchResultCardProgressDto'];
export type SearchSuggestionsResponseDto =
  components['schemas']['SearchSuggestionsResponseDto'];

export enum SearchMode {
  AI = 'ai',
  BASIC = 'basic',
}

export enum SearchSourceType {
  CONTENT = 'content',
  PRODUCT = 'product',
  CURRICULUM = 'curriculum',
  MODULE = 'module',
  ACTIVITY = 'activity',
}

export type SearchQueryParams = {
  query: string;
  page?: number;
  perPage?: number;
  types?: SearchSourceType[];
};

export const apiSearch = (
  params: SearchQueryParams,
): Promise<SearchResultsResponseDto> => {
  const api = useApi();
  return api('/app/search', { params });
};

export type SearchSuggestionsQueryParams = {
  query: string;
  types?: SearchSourceType[];
};

export const apiGetSearchSuggestions = (
  params: SearchSuggestionsQueryParams,
): Promise<SearchSuggestionsResponseDto> => {
  const api = useApi();
  return api('/app/search/suggestions', { params });
};
